import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function RADPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Results and Discussion</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p style={{ fontSize: "1.1em" }}>
              <ul>
                <li style={{ fontSize: "1.3em" }}>
                  {" "}
                  <b>Land Cover</b>{" "}
                </li>
              </ul>
              <p style={{ fontSize: "1.1em" }}>
                Normalized Difference Vegetation Index (NDVI) provided land
                cover, presented in Figure 1, which aided as a key indicator of
                the spatial extent of vegetation. Supplementary Table S1
                provides temporal land cover details, which reveal that in 1973,
                vegetation occupied 2347.43 sq. km (63.41%) and witnessed
                changes subsequently, and the highest cover was observed in 1990
                (2474.76 sq. km, 66.90%). The land cover changes are indicative
                of land use changes with anthropogenic influences.
              </p>
              <p style={{ fontSize: "1.1em", textAlign: "center" }}>
                <img
                  width={900}
                  height={600}
                  src="images/final_images/Figure1.png"
                  alt=""
                />
                <br />
                <strong>Figure </strong>
                <strong>1</strong>
                <strong>.</strong> Land cover dynamics in Goa, Central Western
                Ghats. Created using the open-source software QGIS 3.10
                [https://www.qgis.org/] and GRASS GIS 7.8.2
                [https://wgbis.ces.iisc.ac.in/grass/].
              </p>
              <ul>
                <li style={{ fontSize: "1.3em" }}>
                  {" "}
                  <b>Land Use</b>{" "}
                </li>
              </ul>
              <p style={{ fontSize: "1.1em" }}>
                The land use dynamics assessed over the last five decades
                (1973-2022) using remote sensing data, given in Figure 2, reveal
                that the extent of evergreen forests increased from 495.12 sq.
                km (13.37%) in 1973 to 520.34 sq. km (14.06%) in 1998, due to
                the regeneration of evergreen species with stringent forest
                protection measures (Supplementary Table S2). However, a decline
                in evergreen forests during the post-globalization period
                (1990s) is evident from the spatial extent of 497.31 sq. km
                (13.43%) in 2022. Moist deciduous forest cover declined from
                1029.43 sq. km (27.81%) in 1977 to 838.04 sq. km (22.64%) in
                2022. Dry deciduous and shrubland areas increased notably, from
                477.03 sq. km (12.89%) in 1973 to 616.99 sq. km (16.67%) in
                2022, which suggests degradation of forest ecosystems with a
                shift in vegetation composition towards more arid or semi-arid
                ecosystems.
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Open spaces experienced a substantial reduction from 711.19 sq.
                km (19.21%) in 1973 to 207.1 sq. km (5.59%) in 2022 due to urban
                expansions with the consistent growth in built-up areas from
                22.2 sq. km (0.6%) in 1973 to 180.94 sq. km (4.89%) in 2022.
                Urbanization with the decline of native vegetation cover
                exacerbates hydrological processes, leading to increased runoff
                and reduced water retention [90, 25]. The loss of vegetation
                cover contributes to increased soil erosion and alters water
                quality, as more sediment and pollutants enter water bodies.
                Unplanned developmental activities have contributed to rapid
                urbanization leading to sprawl with the expansion of major
                cities such as Panaji, Mormugao, Ponda, and Mapusa and
                industrial areas like Verna, which has profound impacts with
                fragmentation of ecosystems, resulting in biodiversity losses
                and erosion of essential ecosystem functions [23]. This process
                leads to significant declines in species richness and genetic
                diversity, with smaller and more isolated forest fragments
                experiencing the greatest biodiversity loss due to reduced
                habitat size and increased isolation [91]. &nbsp;
              </p>
              <p style={{ fontSize: "1.1em", textAlign: "center" }}>
                <img
                  width={900}
                  height={600}
                  src="images/final_images/Figure2.png"
                  alt=""
                />
                <br />
                <strong>Figure </strong>
                <strong>2</strong>
                <strong>. </strong>Land use dynamics in Goa. Created using the
                open-source software QGIS 3.10 [https://www.qgis.org/] and GRASS
                GIS 7.8.2 [https://wgbis.ces.iisc.ac.in/grass/].
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Supplementary Figure S1 highlights the trends in land use
                transitions. The agricultural landscape expanded, with croplands
                peaking at 333.5 sq. km (9.01%) in 2018, and horticultural areas
                steadily increased to 416.39 sq. km (11.25%) in 2022 from 337.63
                sq. km (9.12%) in 1973. Cashew plantations witnessed a steep
                increase in the last five decades, covering 4.26% of the Goa
                landscape. Mining activities were at the peak in 1998, covering
                41.47 sq. km (1.12%). Monoculture plantation of exotic species
                like{" "}
                <em>
                  Acacia auriculiformis, Tectona grandis, Eucalyptus globulus,
                  Casuarina equisetifolia L., Hevea brasiliensis,
                </em>{" "}
                and others increased from 0.89% (1973) to 2.43% (2022).
                Supplementary Table S2 provides land use transitions,
                highlighting the need for land cover monitoring to address
                emerging environmental challenges and foster landscape
                resilience through sustainable land use practices.
              </p>
              <ul>
                <li style={{ fontSize: "1.3em" }}>
                  {" "}
                  <b>Land Use Modeling</b>{" "}
                </li>
              </ul>
              <p style={{ fontSize: "1.1em" }}>
                Prediction of likely land uses was made in two scenarios: (i) a
                Business-as-usual (BAU) or natural increase scenario, and (ii)
                an agent-based simulation of land use, Analytical Hierarchical
                Process (AHP) CA-Markov method using Multi-Criteria Evaluation
                (MCE). The modeling outcome is validated by comparing the actual
                land uses of 2022 with the simulated land uses of 2022. In the
                case of the BAU scenario, the accuracy is K<sub>no</sub> =
                0.8376, K<sub>location</sub> = 0.8344, K
                <sub>locationStrata</sub> = 0.8344, and K<sub>standard</sub> =
                0.794. While in AHP-based modeling, the accuracy is K
                <sub>no</sub> = 0.8417, K<sub>location</sub> = 0.8344, K
                <sub>locationStrata</sub> = 0.8344, and K<sub>standard</sub> =
                0.7998, which highlights agreement between actual and simulated
                land uses. Hence, this approach was adopted for predicting
                likely land uses in 2038. In both scenarios, the Built-up
                increases, suggesting urbanization or infrastructure
                development, and the percentage of native forest decreases,
                indicating further degradation in the forest ecosystems (Figure
                3).
              </p>
              <p style={{ fontSize: "1.1em", textAlign: "center" }}>
                <img
                  width={900}
                  height={500}
                  src="images/final_images/Figure3.png"
                  alt=""
                />
                <br />
                <strong>Figure 3. </strong>Predicted land uses of 2038 in (a)
                Business-as-usual Scenario and (b) Agent-based scenario. Created
                using the open-source software QGIS 3.10 [https://www.qgis.org/]
                and GRASS GIS 7.8.2 [https://wgbis.ces.iisc.ac.in/grass/].
              </p>
              <p style={{ fontSize: "1.1em" }}>
                The predicted land uses listed in Supplementary Table S3 reveal
                that the spatial extent of evergreen forests is expected to
                decline to 10.67% (BAU) and 10.98% (AHP), and moist deciduous
                land cover remains relatively stable at 22.64% from 2022 to 2038
                in BAU scenario, while AHP scenario indicates a decline to
                19.74% (2038). Dry deciduous and shrubs increase under the BAU
                scenario to 20.52% (in 2038) from 16.67% (2022), indicating a
                shift towards drier vegetation types, while the AHP scenario
                shows a minimal change, and the spatial extent would be 16.64%.
                Mangrove forests and wetland ecosystems show an increasing trend
                in BAU (spatial extent of 1.69% and 2.41%, respectively) and a
                decreasing trend in the AHP scenario (1.06% and 1.85%
                respectively) compared to 1.38% and 2.36% respectively in 2022.
                Waterbodies are likely to decline in both BAU (to 3.30%) and AHP
                scenarios (4.19%) from 4.77% (2022). On the other hand, open
                land cover shows a decreasing trend in both scenarios (Current
                5.59%, BAU 5.14%, AHP 4.82%), reflecting increasing urbanization
                or infrastructure development. Agricultural land is projected to
                expand in BAU (9.34%) from 2022 (7.42%) but decline in the AHP
                scenario (6.65%) due to the conversion of agricultural lands
                into horticultural land, paved surfaces, etc. Horticulture shows
                a substantial increase in the AHP scenario (spatial extent of
                13.69%) compared to BAU (8.32%). The agriculture and allied
                sectors contribute less than 5% to the state's GDP, but their
                share in the Gross Value Added (GVA) at current prices is
                substantial, amounting to INR 55,06,000 [92].
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Urbanization is expected to intensify in both scenarios, with a
                notable increase under AHP (6.31%) compared to BAU (5.79%), and
                current spatial extent of 4.89%). The area under Built-up with
                horticulture also shows a significant rise in both scenarios.
                The area under mining is expected to increase from 0.61% (2022)
                to 0.7% (2038) in BAU and 0.84% in the AHP scenario. The
                plantation area of exotic species shows a noteworthy increase to
                5.23% in the AHP scenario compared to 2.56% in BAU from 2.43% in
                2022. The analysis of land use dynamics for 2038 under BAU and
                AHP scenarios, presented in Supplementary Table S3, highlights
                that these changes would pose challenges in balancing economic
                activities with environmental sustainability. The AHP scenario,
                characterized by multi-criteria evaluation, presents more robust
                land use estimates than BAU scenario.
              </p>
              <p style={{ fontSize: "1.1em" }}>&nbsp;</p>
              <ul>
                <li style={{ fontSize: "1.3em" }}>
                  {" "}
                  <b>Condition of Forest Ecosystems</b>{" "}
                </li>
              </ul>
              <p style={{ fontSize: "1.1em" }}>
                The condition of forest ecosystems assessed through
                fragmentation metrics (Figure 4, Ecological significance in
                Supplementary Table S4) and results are listed in Supplementary
                Table S5, which highlights interior forest of 1398.38 sq. km
                (42.45%) in 1973, increased to 1571.47 sq. km (42.45 %) in 1977
                due to forest regeneration with the stringent forest
                conservation measures. However, degradation was noticed after
                1977, as the interior forest decreased to 1375.06 sq. km
                (37.14%) in 2022 (Figure 4). Meanwhile, the non-forest area
                decreased from 1590.53 sq. km (1973) to 1410.84 sq. km (1990)
                and then increased to 1590.22 sq. km (2022). The fragmentation
                of forests restricts animal movement, leading to inbreeding with
                gene extirpation and, eventually, the extinction of endemic
                species. Additionally, their isolation diminishes adaptability
                to environmental changes, which enhances vulnerability to
                diseases [93]. The loss of biodiversity also erodes ecosystem
                services (such as pollination, pest control, etc.) which are
                crucial for maintaining healthy ecosystems [94].
              </p>
              <p style={{ fontSize: "1.1em" }}>
                &ndash;&ndash;&ndash;&ndash;&ndash;&ndash;
              </p>
              <p style={{ fontSize: "1.1em", textAlign: "center" }}>
                <img
                  width={800}
                  height={500}
                  src="images/final_images/Figure4.png"
                  alt=""
                />
                <br />
                <strong>Figure 4. </strong>Assessment of the condition of the
                Forest ecosystem of Goa.Created using the open-source software
                QGIS 3.10 [https://www.qgis.org/] and GRASS GIS 7.8.2
                [https://wgbis.ces.iisc.ac.in/grass/].
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Supplementary Figure S2 depicts the dynamics of forest
                fragmentation from 1973 to 2022. Figure 5 illustrates intact
                forests (interior), and various levels of fragmentation (such as
                patch, perforated, edge, transition, etc.). The principal agents
                of fragmentation of forests include anthropogenic activities of
                agricultural and horticultural (including coconut, cashew, and
                other horticulture), mining and waste dumping, construction of
                buildings, expansion of roads and power lines through forested
                areas, and large-scale plantations of exotic monoculture species
                like <em>Acacia auriculiformis</em>, etc. Monoculture
                plantations have detrimental effects on the overall resilience
                of the ecosystem evident from the reduced infiltration of
                precipitation, decline of pollinators, soil micro-organisms,
                etc. [25, 95]. The absence of diverse plant species disrupts
                ecological interactions, potentially impairing the ecosystem's
                ability to withstand environmental stresses and maintain
                essential ecological processes [95, 96].
              </p>
              <p style={{ fontSize: "1.1em" }}>
                &ndash;&ndash;&ndash;&ndash;&ndash;&ndash;&ndash;
              </p>
              <p style={{ fontSize: "1.1em", textAlign: "center" }}>
                <img
                  width={800}
                  height={500}
                  src="images/final_images/Figure5.png"
                  alt=""
                />
                <br />
                <strong>Figure 5. </strong>Condition of forest ecosystems
                (highlighting various levels of fragmentation). Created using
                the open-source software QGIS 3.10 [https://www.qgis.org/] and
                GRASS GIS 7.8.2 [https://wgbis.ces.iisc.ac.in/grass/].
              </p>
              <ul>
                <li style={{ fontSize: "1.3em" }}>
                  {" "}
                  <b>Carbon sequestration</b>{" "}
                </li>
              </ul>
              <p style={{ fontSize: "1.1em" }}>
                Carbon sequestration in forest ecosystems is accounted for
                through field data collection and the compilation of information
                from published literature [30, 39, 97], which are listed in
                Supplementary Table S6. Supplementary Figure S3 depicts the
                spatial variability of carbon, which highlights that very dense
                forested areas are endowed with higher biomass (44012.40 Gg).
                Moderately dense and degraded forests represent 2320.09 Gg and
                7051.61 Gg of carbon. The total quantum of carbon sequestered is
                53384.11 Gg in the forest ecosystems (based on 2022 land use)
                (Figure 6). The ecosystem supply value of carbon sequestration
                service is calculated by considering the social cost of carbon
                per ton as US$ 80 using the GDP deflator [39, 98]. The carbon
                sequestration from forests is quantified through the InVEST
                model
                (https://naturalcapitalproject.stanford.edu/software/invest),
                which shows that the carbon sequestration ranges from 292.84,
                15.44, and 46.92 billion INR for very dense, moderately dense,
                and degraded forest ecosystems.
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Figure 6 highlights the spatial variability of mangroves (51.16
                sq. km), which store carbon of 2747.05 Gigagrams (Gg). Notably,
                the carbon sequestration service of forest ecosystems amounts to
                18.28 billion INR, highlighting the role of mangrove ecosystems
                in sustaining livelihood while mitigating changes in the
                climate. The carbon sequestration values of very dense,
                moderately dense, and degraded mangrove ecosystems are
                highlighted in Supplementary Figure S4.
              </p>
              <p style={{ fontSize: "1.1em", textAlign: "center" }}>
                <img
                  width={900}
                  height={300}
                  src="images/final_images/Figure6.png"
                  alt=""
                />
                <br />
                <strong>Figure 6. </strong>Carbon sequestration services of
                terrestrial forest ecosystems in Goa. Created using the
                open-source software QGIS 3.10 [https://www.qgis.org/] and GRASS
                GIS 7.8.2 [https://wgbis.ces.iisc.ac.in/grass/].
              </p>
              <ul>
                <li style={{ fontSize: "1.3em" }}>
                  {" "}
                  <b> Prioritization of Ecologically Sensitive Regions (ESR)</b>
                </li>
              </ul>
              <p style={{ fontSize: "1.1em" }}>
                Ecologically Sensitive Regions (ESR) in Goa have been
                prioritized at disaggregated levels for the decentralized
                governance of fragile ecosystems through insights into
                ecological fragility by considering landscape (ecosystem extent
                and condition), ecological, geo-climatic, hydrological, energy
                availability, and social characteristics. Table 1 illustrates
                that 33.82% and 20.59% of the region are under ESR1 and ESR2,
                which depicts the highest ecologically sensitive zones.&nbsp;
                ESRs with attribute information can be geo-visualized virtually
                in WGSDSS - Western Ghats Spatial Decision Support System
                (https://wgbis.ces.iisc.ac.in/sdss/wgsdss/index.php) [13]. ESR1
                and ESR2 are ecologically highly fragile, and these regions are
                to be protected without any anthropogenic developmental
                activities ESR3 and ESR4 cover 16.18% and 29.41% (Figure 7),
                where sustainable development should be practiced with prudent
                management while protecting critical natural resources.
              </p>
              <ul>
                <li style={{ fontSize: "1.3em" }}>
                  {" "}
                  <b>Valuation of Ecosystem Services (VES)</b>{" "}
                </li>
              </ul>
              <p style={{ fontSize: "1.1em" }}>
                Ecosystem services have been quantified as per the UN-SEEA
                framework [99, 39]. Table 1 lists the provisioning services,
                regulating services (including Carbon sequestration), cultural
                services and total ecosystem supply value (TESV) of the forest
                ecosystem. The total ecosystem supply value (TESV) of forest
                ecosystems in Goa amounts to 481.76 billion INR (2022).
                Provisioning services constitute 12%, regulating services 84%,
                and cultural services 4% of TESV (Figure 7).
              </p>
              <table width="100%">
                <tbody>
                  <tr>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>Ecological Sensitiveness </strong>
                      </p>
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>&nbsp;</strong>
                      </p>
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>Details</strong>
                      </p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>ESR1</strong>
                      </p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>ESR2</strong>
                      </p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>ESR3</strong>
                      </p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>ESR4</strong>
                      </p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>Total</strong>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>
                        Spatial extent of Forest ecosystem (ha)
                      </p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>90988.81</p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>57514.94</p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>20070.60</p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>22133.89</p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>190708.24</strong>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td style={styles.cell} colspan="6">
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>Ecosystem Services</strong>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>
                        Provisioning Million ₹
                      </p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>25742.48</p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>16548.29</p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>6040.15</p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>6753.03</p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>55083.95</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>Regulating Million ₹</p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>219764.82</p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>108028.27</p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>38371.87</p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>40076.59</p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>406241.55</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>Cultural Million ₹</p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>9550.45</p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>6139.41</p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>2240.89</p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>2505.37</p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>20436.11</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={styles.cell} colspan="6">
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>Total Ecosystem Supply Value (TESV)</strong>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>TESV Million ₹</p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>255057.75</p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>130715.97</p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>46652.91</p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>49334.98</p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>481761.61</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>TESV Billion ₹</p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>255.06</p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>130.72</p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>46.65</p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>49.33</p>
                    </td>
                    <td style={styles.cell}>
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>481.76</strong>
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p style={{ fontSize: "1.1em" }}>
                <strong>Table 1.</strong> Quantification of Ecosystem Services
                of forest ecosystem (based on eco-sensitiveness) of Goa.
              </p>
              <p style={{ fontSize: "1.1em", textAlign: "center" }}>
                <img
                  width={800}
                  height={500}
                  src="images/final_images/Figure7.png"
                  alt=""
                />
                <br />
                <strong>Figure 7. </strong>Visualization of eco-sensitive
                regions at disaggregated levels through the Western Ghats
                Spatial Decision Support System (WGSDSS -
                https://wgbis.ces.iisc.ac.in/sdss/wgsdss/v2/)
              </p>
              <p style={{ fontSize: "1.3em" }}>
                <strong>Discussion</strong>
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Forest ecosystems in Goa provide diverse services vital for
                human well-being and economic prosperity, and valuing these
                services is crucial for prudent management through informed
                decision-making. TESV accounts for 481.76 billion INR/year (in
                2022), with regulating services constituting a substantial 84%,
                which highlights the role of ecosystems in maintaining
                environmental health while mitigating changes in the climate.
                Values of the forest ecosystem services accounted for Goa,
                Central Western Ghats are comparable to earlier studies &ndash;
                (i) 456.47 billion INR /year from forests of neighboring Uttara
                Kannada district [95], (ii) a decline of TESV from 2,841 billion
                INR/year (2005) to 1,835 billion INR/ year (2019), highlights
                the implications of 35% decline in the forest ecosystems [39],
                (iii) the total economic value of Himachal Pradesh forests at
                1066 billion INR per year [38], (iv) value of ecosystem services
                of Arunachal Pradesh State tropical forests to be 1,518 billion
                INR per year [41], (v) valuation of ecosystem services provided
                by several tiger reserves in India [40], reveal significant
                annual flow benefits: Corbet (US$ 227 million/year), Kanha (US$
                253 million/year), Kaziranga (US$ 150 million/year), Periyar
                (US$ 271 million/year), Ranthambore (US$ 128 million/year), and
                Sundarbans (US$ 197 million/year) (vi) the recreational value of
                Rajaji National Park to be 248.63 million INR/year [37].
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Valuing the economic benefits of carbon sequestration provides
                insights for conservation through sustainable land management
                practices to mitigate escalating GHG footprint [100, 101]. Local
                and regional assessments of carbon sequestration would aid in
                the conservation and support of community livelihoods through
                informed decision-making for sustaining ecological processes
                [102]. The total tree carbon density for Central India varies
                from 48.97 to 214.97 Mg C per hectare [105]. Forest ecosystems
                of Goa store 56131.16 Gg of carbon, which accounts for 373.47
                billion INR ($ 4.49 billion), considering $80 per ton as the
                social cost of carbon [39]. &nbsp;Similarly, carbon stored in
                forest ecosystems of the Western Ghats is INR 100 billion, based
                on a carbon trading price of INR 2142 (US$30) per tonne [30].
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Large-scale land-use changes leading to land degradation and
                deforestation have significantly impacted the ecological
                functioning of forest ecosystems contributing to climate change
                [95, 104]. Assessment of land-use dynamics reveals a 3.75%
                decline with globalization in the 1990s, with rapid unplanned
                urbanization to cater to the burgeoning population needs,
                infrastructure, and market demand. Goa witnessed increased
                forest cover (the 1970s and 1980s) with the ban on shifting
                cultivation after independence (1961). The Draft National Forest
                Policy 2018 [105] stipulated one-third of forest cover to
                address national needs with conservation, for addressing soil
                erosion, forest degradation (caused by shifting cultivation),
                etc. The Policy emphasizes the need to maintain ecological
                balance to ensure environmental stability and arrest the
                degradation of forests. The prohibition of shifting cultivation
                and establishing wildlife conservation areas, national parks,
                and biosphere reserves supported the regrowth or regeneration of
                native vegetation.
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Many villages of Goa have witnessed a significant decline in
                agricultural productivity due to environmental degradation and
                lowered fertility of the Khazan wetlands [106]. Understanding
                the drivers of land-use change at disaggregated levels would aid
                in prioritizing critical ecosystems for conservation. Unlike
                conventional prediction models, Agent-Based Models (ABM) harness
                dynamic simulations of actual systems, providing effective tools
                for forecasting future performance and taking proactive measures
                to manage risks. Agent-based models focus on abstract,
                microsocial models and uncover causal mechanisms, including
                climate policy analysis [107, 108].
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Intense mining activities had a detrimental impact on the local
                communities, primarily through land dispossession, lowered yield
                due to dust pollution, and failing health of the local
                population with widespread environmental damage [109, 110].
                Mining activities in Goa were restricted in October 2012 due to
                environmental concerns. Subsequently, in February 2018, the apex
                Court delivered a definitive judgment, declaring all mining
                leases in Goa are illegal because of violations of various
                environmental and mining regulations, including the MMDR Act,
                the Forest (Conservation) Act, and the Environment (Protection)
                Act.
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Goa has undergone a significant change in the spatial extent of
                mangroves [111], with the abandonment of Khazan farming, and
                along Chapora, Mandovi, Cumbarjua, and Sal Rivers, mangroves
                have witnessed a remarkable resurgence. The increase in the
                spatial extent of mangrove cover from 19.73 sq. km to 51.16 sq.
                km is due to the sustained conservation and reforestation
                efforts with initiatives such as the declaration of Chorao
                Island in the Mandovi Estuary as a bird sanctuary in 1987 and
                the plan to develop 50 hectares of mangrove plantations annually
                by the Goa State Social Forestry Division as part of the
                National Mangrove Plan [112]. The decline in both cultivated
                areas with increased fallow land coincides with the diminishing
                interest of farmers in agricultural pursuits, attributed to low
                productivity and rising uncertainty in precipitation patterns
                [113].
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Forest ecosystems are vital to sustain the balance in the global
                carbon cycle considering escalating anthropogenically induced
                rise in greenhouse gas emissions and the decline of carbon
                sequestration capability present a dual threat of loss of
                ecosystem services and exacerbation of climate change. The
                extent and condition of forest ecosystems are assessed using
                temporal remote sensing data through supervised machine learning
                techniques. The quantification of land use dynamics reflects the
                urban expansion, which is evident in the consistent increase in
                built-up areas from 0.6% (22.2 sq. km) in 1973 to 4.89% (180.94
                sq. km) in 2022. Large-scale land-use changes leading to the
                decline of forests during post-1990 were due to globalization
                and a spurt in market activities with infrastructure development
                [114].
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Assessment of likely land use changes using agent-based modeling
                indicates that there will be a further decline in evergreen
                forest cover in both BAU (10.67%) and AHP (10.98%), emphasizing
                the need for conservation efforts. Invasive species pose a
                significant threat to biodiversity, acting as potent drivers of
                ecosystem service disruption and consequently causing profound
                alterations in socio-economic conditions through diverse
                mechanisms. Monoculture plantation of exotic species such as{" "}
                <em>
                  Acacia auriculiformis, Tectona grandis, Eucalyptus globulus,
                  Casuarina equisetifolia L., Hevea brasiliensis
                </em>
                , etc. shows a noteworthy increase in the AHP scenario (5.23%).
                This assessment, with insights into the ecosystem's sensitivity,
                vulnerability, and resilience to unforeseen changes, facilitates
                the development of informed biodiversity protection strategies
                and offers a critical decision-making framework for sustainable
                biodiversity protection plans, which safeguards the natural
                resources with the long-term flow of crucial goods and services
                for future generations [68].
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Ecosystem services contribute to economic welfare in two ways
                &ndash; (i) contributions to the generation of income and
                well-being and (ii) the prevention of damages that inflict costs
                on society [39]. These benefits are accounted for in policy
                appraisal with a broader focus on valuing the benefits provided
                by ecosystems. Policy options that enhance the natural
                environment are more likely to be considered, demonstrating that
                investing in natural capital would make economic sense [99].
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Goa state, India, is trying to accelerate economic growth, and
                there has been tremendous pressure to divert natural systems to
                other uses. Hence, there is an urgent need to undertake the
                natural capital accounting and valuation of the ecosystem
                services, especially intangible benefits (such as regulating
                services, etc.), provided by ecosystems. The value of all
                ecosystem services, including the degradation costs, needs to be
                understood to develop appropriate policies toward ecosystem
                conservation and sustainable management [115]. Scientific
                efforts during the past decade have refined the understanding of
                ecosystem function and demonstrated the links between ecosystem
                functions and the provision of ecosystem services [39, 115-118].
                This knowledge needs to be communicated effectively to
                decision-makers and the public, which will lead to developing
                policies that adequately consider the trade-offs between the
                conservation of natural resources and economic growth.
              </p>
              <p style={{ fontSize: "1.1em" }}>
                The overall assessment of the ecological services provides
                information for prioritizing ecosystems for sustainable land-use
                practices, promoting off-farm incomes to the dependent
                communities, restoring degraded sites, biodiversity
                conservation, integrated management of water resources, etc.
                while promoting community-based prudent management of natural
                resources. There is a need to enhance awareness of the
                protection of the environment, especially the maintenance of
                native forest cover, which is crucial for balanced economic and
                social progress in the region. Over the last few decades, though
                environmental legislation, policies, and programs for
                environmental protection and conservation of natural resources
                have evolved, these policies and programs have been unevenly
                implemented. Thus, ecosystem accounting can play a role in two
                ways. First, ecosystem accounts can help policymakers factor in
                ecosystem service benefits when making economic policies that
                impact natural resources and ecosystems. Second, ecosystem
                accounts, which are regularly compiled, can be used to help
                monitor the impact of these policies over time and ensure that
                they are being implemented properly.
              </p>
              <p style={{ fontSize: "1.3em" }}>
                <strong>Limitations of the current study</strong>
              </p>
              <ol>
                <li style={{ fontSize: "1.1em" }}>
                  Ecosystem services have varying spatial and temporal scales,
                  such as the benefits at local levels (of provisioning services
                  and regulating services such as soil conservation, flood
                  mitigation, water purification, etc.), while climate
                  regulation services are global, and valuation must consider
                  the full geographical extent and long-term impacts of
                  ecosystem changes.
                </li>
                <li>
                  Cultural services, such as recreational and spiritual values,
                  are difficult to monetize due to their subjective nature and
                  can lead to underrepresenting these services in economic
                  valuations despite their significant importance in sustaining
                  local livelihood.
                </li>
                <li>
                  There is considerable complexity in understanding and
                  assessing the underlying links between a policy, its effects
                  on ecosystems and related services, and valuing its impacts in
                  economic terms. Collaboration between those working in policy,
                  science, and economics disciplines is essential in
                  implementing this approach in practice. The critical
                  importance of the links to scientific analysis, which form the
                  basis for valuing ecosystem services, needs to be recognized.
                </li>
              </ol>
              <p style={{ fontSize: "1.3em" }}>
                <strong>Recommendations for policy intervention</strong>
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Forest ecosystems in Goa State have witnessed change and
                degradation since their value is poorly understood and not
                considered in the policy-making process. The assessment of the
                extent and condition of forest ecosystems at regular intervals,
                taking advantage of advancements in geoinformatics with
                artificial intelligence and deep learning algorithms, and the
                availability of spatial data at regular intervals to estimate
                the economic value of ecosystems forests and reflect the value
                of forests in policy decisions.
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Forests provide various services classified as provisioning,
                regulating, and cultural services. Most of these services are
                underestimated or not estimated and are thus undervalued in
                policy decisions. Poor understanding of the complex ecological
                processes and proper estimation of the ecosystem benefits have
                often led to the destruction of fragile ecosystems. To improve
                the scenario, a thorough understanding of the complex ecosystem
                dynamics and its socio-religious association with community life
                is important from a conservation and management point of view.
                However, the valuation of regulating services and cultural
                services is challenging to estimate and thus poses serious
                challenges to planners and practitioners.&nbsp; Hence, the
                valuation of the ecosystem services in the income accounting of
                a region/nation is essential to make plans and policies more
                sustainable. The accounting of the forest sector in Goa
                increases the prospects in terms of more investment in the
                forest sector, reducing the risk of disaster, more business
                opportunities, curbing biodiversity loss, biodiversity
                conservation, ensuring food and ecological balance, etc.&nbsp;
              </p>
              <p style={{ fontSize: "1.1em" }}>
                The ecosystem services computed for Goa State also support the
                viability of markets for ecosystem services. The development of
                such markets requires additional institutional reforms, such as
                changes with respect to property rights and reforms in land and
                labor markets. Hence, ecosystem services need to be internalized
                in decision-making, strengthening the economic case for
                conserving forests in all states in India and developing
                countries, as there is great pressure to relax forest laws and
                divert forests to non-forest uses. The main policy challenge is
                to promote conservation and develop such markets so that those
                bearing the cost of conservation are adequately compensated.
                This will also support local communities in their efforts to
                sustainably manage forest resources, recognizing their
                traditional practices and knowledge. There is an urgent policy
                need for more comprehensive assessments of the natural capital
                of ecosystems, which will aid in comparing these aggregate
                values with the opportunity cost of this land. Policymakers need
                such information to gain support for conservation funding,
                engage local communities, and develop market-based instruments
                for conservation. This necessitates accounting for the natural
                capital found in the forest ecosystems (among others) and
                incorporating their economic worth added to the measurement of
                the wealth of a region. Ecosystem services accounting for Goa
                state have a large potential to be used for payment for
                ecosystem services schemes. The Supreme Court of India (2006)
                [119] directed the national government to set up compensatory
                payments for converting forest land to non-forest uses and use
                these payments to improve India&rsquo;s forest cover.
              </p>
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default RADPage;
